(function () {
  /* AMAR - aggiunta del Diwan dal traguardo di spedizione, senza cambio pagina.

     Il collegamento nel carrello e' un permalink Shopify (/cart/<variante>:1):
     funziona da solo, anche senza JS, aggiungendo il prodotto e ricaricando il
     carrello. Qui lo si intercetta soltanto per fare la stessa cosa in modo
     silenzioso e restare nel cassetto.

     Nessun riferimento a un elemento preciso: l'ascolto e' delegato al
     documento, perche' il riepilogo del carrello viene rirenderizzato a ogni
     aggiornamento e qualunque riferimento diretto sarebbe scaduto al secondo
     clic.

     A fine aggiunta si annuncia cart:update senza sezioni: il componente del
     carrello, non trovandole, richiede da solo la sezione aggiornata al
     server. E' la stessa strada che il tema usa quando l'aggiunta arriva da
     una scheda prodotto. */

  function shopRoot() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var target = event.target;
    var cta = target && target.closest ? target.closest('[data-amgo-add]') : null;
    if (!cta) return;

    var variant = Number(cta.getAttribute('data-amgo-add'));
    if (!variant) return;

    event.preventDefault();
    if (cta.getAttribute('aria-busy') === 'true') return;
    cta.setAttribute('aria-busy', 'true');

    fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function () {
        return fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'amar-cart-goal', data: { source: 'amar-cart-goal' } }
          })
        );
      })
      .catch(function () {
        /* Se la rete non risponde si torna al comportamento del collegamento:
           il prodotto viene comunque aggiunto, con un cambio pagina. */
        var href = cta.getAttribute('href');
        if (href) window.location.href = href;
      })
      .then(function () {
        cta.removeAttribute('aria-busy');
      });
  });
})();
